import { useGetProfile } from './useGetProfile'
import { Loader } from 'components/Loader'

export const GetProfile: React.FC = () => {
    useGetProfile()

    return <Loader />
}